<template>
  <div class="folder_ty1 clear">
    <div class="folder_nav">
      <div class="folder_list">
        <div class="add">
          <button type="button" @click="UTS025OpenModal">{{$i18nUtil.trans("entity.category.depth2.add","과정 추가")}}</button>
        </div>
      </div>
      <draggable :disabled="!enabled" ghost-class="ghost" :move="checkMove" class="folder_list"
      @change="onChangeDraggable"
      v-model="myFolderList"
      draggable=".draggable_category"
      @start="dragging = true" @end="dragging = false"
      ><!-- :ref="`listFolder_`+element.category.categoryMid" -->
        <div class="draggable_category" v-for="(element, idx) in myFolderList" 
             :key="idx" v-bind:class="element.category.categoryMid == selectedFolder.categoryMid ? 'active' : ''">
          <button type="button" @click="selectCategory($event, element)" :id="'folder_'+idx"
            class="ell-singleline" style="max-width: 210px;"
            @mouseover="mouseEvt(true, element, $event)"
            @mouseleave="mouseEvt(false, element, null)"
          >
            {{ element.category.categoryName }}
          </button>
          <div class="tooltip-b tl small" :id="element.category.categoryMid+'_tooltip'" style="display:none; z-index: 10; max-width: 210px; word-break: break-all; top:-10px; left:5px;">
            {{ element.category.categoryName }}
          </div>
          <div class="droplayer icon more right nosel">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
              </template>
              <div class="dropdown-list">
                <div class="dropdown-list-item"><div class="tit"><button type="button" @click="UTS026OpenModal">{{ $i18nUtil.trans("title.RegistCategoryModal.002","과정명 변경") }}</button></div></div>
                <div class="dropdown-list-item"><div class="tit"><button type="button" @click="AB028ModalOpenModal">{{ $i18nUtil.trans("title.DeleteFolderAlert.001","과정 삭제") }}</button></div></div>
              </div>
            </v-menu>
          </div> 
        </div>
      </draggable> 
      
      <!-- //팝업 노출로 인해 퍼블만 사용 E -->
    </div>
    <div class="folder_cnt">
      <div class="cnt_tit">{{ selectedFolder.categoryName }}</div>

      <div class="tb-list_ty1">
        <div class="tb-header clear">
          <div class="tb_num fl">
            <!-- <input type="checkbox" name="" id="name1"> -->
            <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalElements})"></div>
            <!-- 검색 조회시 노출 S -->
            <div class="check_result" v-show="showSearchBoardTitle">
                <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: rtnSearchPaperTitle, cnt: totalElements})"></div>
                <button type="button" @click="clearSearchPaperTitle">초기화</button>
            </div>
            <!-- //검색 조회시 노출 E -->
          </div>
          <div class="tb_sort fr">
              <input type="checkbox" name="" id="checkReadfilter" v-model="checkFilterRead" @change="checkReadfilter"><label for="checkReadfilter">{{ $i18nUtil.trans("button.paper.unread", "미확인 보드 보기") }}</label> 
              <input type="checkbox" name="" id="chkBookmarkFilter" v-model="isBookmarkFilter" @change="fireFilterBookmark">
                <label for="chkBookmarkFilter">{{ $i18nUtil.trans("button.favorite", "즐겨찾기 보기") }}</label>
              <div class="dividing_line_ty1"></div>
              <div class="search_ty2">
                <button type="button" class="search-show" @click="isSearchArea = true" :class="isSearchArea ? 'active' : ''">검색</button>
                <form action="" @submit.prevent="false == false" onsubmit="return false;" class="search-show">
                  <div class="input-box">
                    <input type="text" 
                      class="search-show" 
                      :class="searchPaperTitle == '' ? 'ico_search' : ''" 
                      v-model="searchPaperTitle" 
                      @keyup.enter="getListTabDashboardBoardList(null, true)"
                      :placeholder="$i18nUtil.trans('message.BoardList.001','보드명 검색')"
                      @focus="$event.target.placeholder=''"
                      @focusout="$event.target.placeholder=$i18nUtil.trans('message.BoardList.001','보드명 검색')"
                      maxlength="21"
                    />
                    <button type="reset" 
                      class="input-txt-del search-show" 
                      @click="searchPaperTitle = ''" 
                      v-if="searchPaperTitle != ''"
                    >
                      입력 삭제
                    </button>
                    <button type="reset" 
                      class="btn_search search-show" 
                      @click="getListTabDashboardBoardList(null, true)"
                    >
                      검색
                    </button>
                  </div>
                </form>
              </div>
              <CommonFilterE :filterReset="filterReset" :isPrivateBoard="true" @updateCommonFilterE="updateCommonFilterE" :initFilter="initFilter" />
          </div> 
        </div><!-- //tb-header -->

        <v-data-table
          :headers="headers"
          :items="boardListFilter"
          :page.sync="page"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :must-sort="true"
          :items-per-page="itemsPerPage"
          :server-items-length="totalElements"
          hide-default-footer
          class="tb-contents ins002a">
          <template v-slot:item="{ item }">
            <tr :class="item.isState">
              <td class="division">
                <div type="button" :class="getEvaluateClassAndText(item).evaluateClass">
                    {{getEvaluateClassAndText(item).evaluateText}}
                </div>
                <div class="subject ell-multiline2" @click="moveBoard(item)">{{ item.paperTitle }} <span :class="item.icoNew"></span></div>
                
                  <UserInfo 
                    :userId="item.regUserId" 
                    :userName="item.regUserName" 
                    :userNameEn="item.regUserNameEn"
                    :userCount="item.paperUserCount" 
                    :paperId="item.paperId" 
                  />
              </td>
              <td class="txtc">
                <button 
                  type="button" 
                  class="ico-switch_favorites small active" 
                  v-show="item.paperBookmarkId != null" 
                  @click="toggleBookmark(item)"
                >
                  즐겨찾기
                </button>
				        <button 
                  type="button" 
                  class="ico-switch_favorites small" 
                  v-show="item.paperBookmarkId == null"
                  @click="toggleBookmark(item)"
                >
                  즐겨찾기
                </button>
              </td>
              <td class="feedback txtc">
                <span class="ico-txt_comment" v-if="item.commentCount < 1000">{{ item.commentCount }}</span>
				        <span class="ico-txt_comment" v-if="item.commentCount > 999">999+</span>
              </td>
              <td class="date txtc">
                <!-- 24시간 이내-->
                <momentAgo v-if="checkHours(item.lastUpdDate)" prefix="" suffix="전" :date="item.lastUpdDate" lang="kr"></momentAgo>
                <!-- 24시간 이후-->
                {{ !checkHours(item.lastUpdDate) ? replaceAll(item.lastUpdDate.substring(0, 10), "-", ".") :''}}
                <span class="ico-new" v-if="item.readCount == null || item.readCount == 0"></span>
                <!-- {{ !checkHours(item.lastUpdDate) ? item.lastUpdDate.substring(0,10).replaceAll("-", ".") : '' }} -->
              </td>
              <td class="author txtc">
                <div class="droplayer tooltipmember relative right">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">
                        <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.lastUpdUserName : item.lastUpdUserNameEn != null ? item.lastUpdUserNameEn : item.lastUpdUserName }}</b>
                      </v-btn>
                    </template>
                    <div class="dropdown-list">
                      <UserTooltip
                        :userId="item.lastUpdUserId"
                      />
                    </div>
                  </v-menu>
                </div>
              </td>
              <!-- <td class="author txtc">{{ item.lastUpdUserName }}</td>/ -->
              <td class="txtc">
                <div class="droplayer icon more right nosel">
                    <v-menu bottom left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
                        </template>
                        <div class="dropdown-list">
                            <div class="dropdown-list-item"><div class="tit"><button type="button" @click="openPaperNewWindow(currentURL(),item);">{{ $i18nUtil.trans("button.paper.open.newWindow","새 창으로 보기") }}</button></div></div>
                            <div class="dropdown-list-item" v-if="sharUse === 'true'"><div class="tit"><button type="button" @click="infoShareReqPost(item);">{{ $i18nUtil.trans("title.ReqPostModal.shareInfo","정보공유 게시") }}</button></div></div>
                            <div class="dropdown-list-item" v-if="cfrcUse === 'true'"><div class="tit"><button type="button" @click="cooperationReqPost(item)">{{ $i18nUtil.trans("title.ReqPostModal.cooperation","회의/협의 게시") }}</button></div></div>
                            <div class="dropdown-list-item"><div class="tit"><button type="button" @click="copyURL(currentURL(),item)">{{ $i18nUtil.trans("button.paper.copy.url","보드 URL 복사") }}</button></div></div>
                            <div class="dropdown-list-item" v-if="tenantId != '203'"><div class="tit"><button type="button" @click="copyPaperModal(item)">{{ $i18nUtil.trans("button.paper.copy","보드 복제") }}</button></div></div>
                            <div class="dropdown-list-item"><div class="tit"><button type="button" @click="deleteBoard(item)">{{ $i18nUtil.trans("button.paper.delete","보드 삭제") }}</button></div></div>
                        </div>
                    </v-menu>
                </div> 
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <div class="nodata-txt-noicon" v-if="boardList.length == 0">
              <v-alert :value="true">
                {{ $i18nUtil.trans("message.BoardList.002","프라이빗 보드를 등록하여 관리해보세요.") }} 
              </v-alert>
              <button v-if="myFolderList.length != 0" type="button" class="btn-primary-small black" @click="addBoard">{{ $i18nUtil.trans("button.paper.user.add","프라이빗 보드 추가") }}</button>
            </div>
            <div class="nodata-txt-noicon" v-if="boardListFilter.length ==0 && boardList.length != 0">
              <v-alert :value="true">
                {{ $i18nUtil.trans("search.007", "조회된 결과가 없습니다.") }}
              </v-alert>
            </div>
          </template>
        </v-data-table>

        <div class="pagination">
          <v-pagination
            v-model="page"
            circle
            :length="pageCount"
            :total-visible="7"
          ></v-pagination>
        </div>
      </div><!-- //tb-list_ty1 -->
    </div>

	<!-- 폴더추가 S -->
    <Modal @close="UTS025closeModal" v-if="UTS025Modal">
      <template slot="tit">
        <div class="tit">{{ $i18nUtil.trans("entity.category.depth2.add","과정 추가") }}</div>
      </template>
      <!-- default 슬롯 콘텐츠 -->
      <div class="input-box">
        <input type="text" 
          :placeholder='$i18nUtil.trans("UB006.001", "추가하실 과정명을 입력해주세요.")'
          @keyup.enter="crudFolder('create')"
          @keyup.esc="UTS025closeModal"
          v-model="addFolderName"
        >
        <button type="button" class="input-txt-del">입력 삭제</button>
        <div class="error" v-if="addFolderError">{{$i18nUtil.trans("UB006","과정명을 입력해주세요.")}}</div>
      </div>
      <!-- /default -->

      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <button type="button" class="btn_ty2" @click="UTS025closeModal">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
        <button type="button" class="btn_ty1" @click="crudFolder('create')">{{ $i18nUtil.trans("button.register","등록") }}</button>
      </template>
      <!-- /footer -->
    </Modal>
    <!-- 폴더추가 E -->

    <!-- 폴더명 변경 S -->
    <Modal @close="UTS026closeModal" v-if="UTS026Modal">
      <template slot="tit">
        <div class="tit">{{$i18nUtil.trans("entity.category.depth2.add","과정 추가")}}</div>
      </template>
      <!-- default 슬롯 콘텐츠 -->
      <div class="input-box">
        <input 
          type="text" 
          :placeholder='$i18nUtil.trans("UB006.002","변경하실 과정명을 입력해주세요.")' 
          @keyup.esc="UTS026closeModal"
          @keyup.enter="crudFolder('update')"
          v-model="updateFolderName"
        >
        <button type="button" class="input-txt-del">입력 삭제</button>
        <div class="error" v-if="changeFolderError">{{$i18nUtil.trans("UB006","과정명을 입력해주세요.")}}</div>
      </div>
      <!-- /default -->

      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <button type="button" class="btn_ty2" @click="UTS026closeModal">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
        <button type="button" class="btn_ty1" @click="crudFolder('update')">{{ $i18nUtil.trans("button.register","등록") }}</button>
      </template>
      <!-- /footer -->
    </Modal>
    <!-- 폴더명 변경 E -->

    <!-- 알림 팝업 S -->
    <ModalSmall @close="AB028ModalcloseModal" v-if="AB028Modal">
      <template slot="tit">
          <div class="tit">{{ $i18nUtil.trans("title.dialog.notice","알림") }}</div>
      </template>
      <!-- default 슬롯 콘텐츠 -->
      <div class="txt1">{{$i18nUtil.trans("message.BoardList.003","과정을 삭제하시겠습니까?")}}</div>
      <!-- /default -->

      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <button type="button" class="btn_ty2">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
        <button type="button" class="btn_ty1" @click="crudFolder('delete')">{{ $i18nUtil.trans("button.delete","삭제") }}</button>
      </template>
      <!-- /footer -->
    </ModalSmall>
    <!-- 알림 팝업 E -->

    <!-- 알림 팝업 S -->
    <ModalSmall @close="AB032ModalcloseModal" v-if="AB032Modal">
      <template slot="tit">
          <div class="tit">{{ $i18nUtil.trans("title.dialog.notice","알림") }}</div>
      </template>
      <!-- default 슬롯 콘텐츠 -->
      <div class="txt1">
          {{$i18nUtil.trans("message.BoardList.004","삭제 시 해당 과정 하위의 보드가 모두 삭제됩니다.")}}
          <br>
          {{$i18nUtil.trans("message.BoardList.003","과정을 삭제하시겠습니까?")}}
      </div>
      <!-- /default -->

      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <button type="button" class="btn_ty1">{{ $i18nUtil.trans("button.confirm","확인") }}</button>
      </template>
      <!-- /footer -->
    </ModalSmall>
    <!-- 알림 팝업 E -->

  </div>
</template>

<script>
// import EventBus from '@/js/store/module/mypage/privateEventBus'
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import draggable from 'vuedraggable'
import Modal from "../../modal/Modal";
import ModalSmall from "../../modal/ModalSmall";
import reqPost from "@/components/cowork/general/project/modal/ReqPostModal";
import CopyBoardModal from "@/components/cowork/general/board/modal/CopyBoardModal";
import UserInfo from "@/components/cowork/common/user/UserInfo";

import CrudFolderModal from "../../modal/CrudFolderModal"
import DeleteFolderAlert from "../../modal/DeleteFolderAlert"
import axios from "axios";
import Vue from 'vue';

import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import CommonFilterE from "@/components/cowork/common/filter/CommonFilterE";
export default {
	name: "BoardList",
	display: "Simple",
	order: 0,
	components: {
		draggable,
		Modal,
    ModalSmall,
    UserInfo,
    UserTooltip,
    CommonFilterE
    // CopyBoardModal,
  },
	data() {
		return {
      tenantId : localStorage.getItem("tenantId"),
			groupInfo: {},
			selectedFolder: {},
			enabled: true,
			UTS025Modal: false,
			UTS026Modal: false,
			AB028Modal: false,
			AB032Modal: false,
      dragging: false,
      sourceDraggableElement: {},
      targetDraggableElement: {},
			page: 1,
			pageCount: 0,
			itemsPerPage: 20,
			boardList: [],
			headers: [
        { text: this.$i18nUtil.trans("entity.paper.filter.paperTitle","보드명"), align: 'center', value: 'paperTitle', sortable: true },
				{ text: this.$i18nUtil.trans("entity.paper.filter.paperBookmar","즐겨찾기"), value: 'paperBookmarkId', sortable: false },
				{ text: this.$i18nUtil.trans("entity.paper.filter.comment","의견/답변"), value: 'commentCount', sortable: true },
				{ text: this.$i18nUtil.trans("entity.paper.filter.lastUpdate","마지막 업데이트"), value: 'lastUpdDate', sortable: true },
				{ text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUserName","생성/수정자"), value: 'lastUpdUserName', sortable: true},
				{ text: this.$i18nUtil.trans("entity.paper.filter.more","더보기"), value: 'more', sortable: false },
			],
      // fileList: [],      
			
      isBookmarkFilter: false,
      filterPaperStatus: "ALL",
      filterLastUpdUser: {
        filterLastUpdUserId: "ALL",
        filterLastUpdUserName: "전체"
      },
      boardListFilter: [],
      greenCount: 0,
      yellowCount: 0,
      redCount: 0,
      parentCategoryMid: null,
      parentCategory: null,
      myFolderList: [],
      addFolderName: null,
      addFolderError: false,
      updateFolderName: null,
      changeFolderError: false,

      groupId:null,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },


      // 필터 수정 1217 
      filterStatus:[],

      filterUserArray:[],
      filterUserList: [],
      filterUserSelected:[],
      filterUserSelectedAll:true,

      checkFilterRead:false,

      searchPaperTitle:'',
      rtnSearchPaperTitle:'',
      isSearchArea: false,
      showSearchBoardTitle :false, 
      
      /* 정렬 */
      totalElements: 0,
      sortBy: ['lastUpdDate'],
      sortDesc: [true],
      /* 페이지 변경 또는 정렬 이벤트시 */
      changeTableData: false,
      gradeCodeList: [],
      statusList: [],
      filterReset: true,
      sharUse: localStorage.getItem("sharUse"),
      cfrcUse: localStorage.getItem("cfrcUse"),

      initFilter:[],
      gradeCheckYn : false,
      statusCheckYn : false,

      defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
		};
  },
  mounted() {
    const self = this;
    $("html").click(function (e) {
      if (!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
          self.isSearchArea = false;
      }
    });
    // let obj = this;
    // EventBus.$on("initPrivateCategoryList", payload => {
    //   obj.getPrivateCategoryList(payload);
    // });
    //this.getMyFlolderList();
	},
	computed: {
		// ...mapState("myPagePrivate", ["myFolderList"]),
		draggingInfo() {
			return this.dragging ? "under drag" : "";
		},
  },
  watch: {
    page: {
      handler() {
        if(this.changeTableData != true) {
          this.changeTableData = true;
        }
        window.scrollTo(0, 0);
      }
    },
    sortBy: {
      handler() {
        if(this.changeTableData != true) {
          this.changeTableData = true;
        }
      }
    },
    sortDesc: {
      handler() {
        if(this.changeTableData != true) {
          this.changeTableData = true;
        }
      }
    },
    changeTableData: {
      handler() {
        let obj = this;
        if(obj.changeTableData == true){
          setTimeout(()=>{
            obj.changeTableData = false; 
            obj.getListTabDashboardBoardList(obj.selectedFolder, false);
          }, 500);
        }
      },
      deep: true
    }
  },
	methods: {
		...mapActions("restAction", ["COWORK_REST_ACTION", "COWORK_REST_SIMPLE_ACTION"]),
		// ...mapActions("myPagePrivate", ["getMyCategoryList"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapMutations("mypage", ["setSelectedFolder"]),
    
    /* 툴팁 */
    mouseEvt(flag, item, event) {
      let tooltipId = item.category.categoryMid+'_tooltip';
      if(flag) {
        // 말줄임(...) css 적용 여부 체크 (boolean)
        let val = this.$tooltip.hasOverflownModalSelectBox(event.target);
        if(val) {
          document.getElementById(tooltipId).style.display = 'block';
        }else{
          document.getElementById(tooltipId).style.display = 'none';
        };
      }else{
        document.getElementById(tooltipId).style.display = 'none';
      }
    },

    initBoardList(groupId, state){
      this.groupId = groupId;
      this.gradeCodeList = [];
      this.statusCodeList = [];
      this.filterReset = true;
      setTimeout(()=>{this.filterReset = false;}, 50);
      if(window.sessionStorage.getItem("moveBoard") === 'true'){
        this.getMyFlolderList();
      }else{
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        if(stateArr.length == 0){
          //저장
          stateArr.push(state);
          window.sessionStorage.setItem("private",JSON.stringify(stateArr));
        }else{
          let lastState = stateArr[stateArr.length-1];
          // let lastState = stateArr.pop();

          if(lastState.currentTab == 0 && lastState.currentTab2 == 0 && lastState.currentTab3 == 0){
            // 같은 탭 누른 경우 .
          }else{
            // 다른 탭에서 누른경우
            if(window.sessionStorage.getItem("prevBtn") === 'true'){
            }else{
              stateArr.push(state);
              window.sessionStorage.setItem("private",JSON.stringify(stateArr));
            }
          }
        }
        
        this.getMyFlolderList();
      }

      // this.getMyFlolderList();
    },
		getMyFlolderList() {
      let obj = this;
      let param = {
				url: '/api/copaper/category/getGroupCategoryList',
				method: 'post',
				req: {
					groupId : this.groupId,
				}
			};
      obj.COWORK_REST_ACTION(param)
				.then(function (res) { 
					if(res.errorCode == null) { 
            obj.parentCategoryMid = res.result[0].parentCategoryMid;
            obj.parentCategory = res.result[0].info;
            obj.myFolderList = res.result[0].list;
            if(obj.myFolderList != null && obj.myFolderList.length > 0) {
              let folderIndex = 0;
              if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
                let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
                let state = stateArr[stateArr.length-1];
                obj.myFolderList.some(function(data, index){
                  if(data.category.categoryMid == state.categoryMid){
                    folderIndex = index;
                    return;
                  }
                });
              }
              obj.getMyPrivateBoardList(obj.myFolderList[folderIndex].category);
              obj.setSelectedFolder(obj.myFolderList[folderIndex]);
            }
					}
				})
				.catch(function (err) {
					console.log(err);
				});
      // this.getMyCategoryList(param) // 해당 공간의 카테고리 및 폴더 리스트
      
		},

		/* 폴더 선택 */
		selectCategory(e, folder) {
      this.isBookmarkFilter = false;
      this.checkFilterRead = false;
      this.getMyPrivateBoardList(folder.category);
      this.setSelectedFolder(folder);
      // if(!e.target.parentElement.classList.contains("active")) {
      // } else {
      //   this.selectedFolder = {};
      //   this.boardList = [];
      //   this.boardListFilter = [];
      //   this.greenCount = 0;
      //   this.yellowCount = 0;
      //   this.redCount = 0;
      // }
      // e.target.parentElement.classList.toggle('active');
    },
    getMyPrivateBoardList(category) {
			this.selectedFolder = category;
			this.getBoardList(this.selectedFolder, false);
    },
    crudFolder(act){
      let obj = this;
			if(act == 'create') {
        if(obj.addFolderName.length !=0) {
          let data = {
            groupId: obj.parentCategory.groupId,
            projectId: obj.parentCategory.projectId,
            section: null,
            parentCategoryMid: obj.parentCategoryMid,
            categoryMid: null,
            categoryName: obj.addFolderName,
            sortNo: null,
            delKbn: "0",
            act: act
          };
          let reqData = {
            object: this,
            data: data,
          };
          obj.addFolderError = false;
          obj.saveCategory(reqData);
        } else{
          obj.addFolderError = true;
        }
			}else if(act == 'update') {
        if(obj.updateFolderName.length != 0){
          let data = {
            groupId: obj.selectedFolder.groupId,
            projectId: obj.selectedFolder.projectId,
            section: obj.selectedFolder.section,
            parentCategoryMid: obj.parentCategoryMid,
            categoryMid: obj.selectedFolder.categoryMid,
            categoryName: obj.updateFolderName,
            sortNo: obj.selectedFolder.sortNo,
            delKbn: obj.selectedFolder.delKbn,
            act: act
          };
          let reqData = {
            object: this,
            data: data,
          };
          obj.changeFolderError = false;
          obj.saveCategory(reqData);
        }else{
          obj.changeFolderError = true;
        }
			}else if(act == 'delete') {
        if(this.myFolderList.length < 2) {
          obj.showAlertDialog(this.$i18nUtil.trans("AB032","등록된 과정이 1개 이하인 경우 삭제할 수 없습니다."));
          return;
        }else{
          if(this.selectedFolder != null) {
            if(this.selectedFolder.paperCount == null || this.selectedFolder.paperCount == 0) {
              if(confirm(obj.$i18nUtil.trans("message.BoardList.005","정말 삭제하시겠습니까?"))) {
                let data = {
                  groupId: obj.selectedFolder.groupId,
                  projectId: obj.selectedFolder.projectId,
                  section: obj.selectedFolder.section,
                  parentCategoryMid: obj.parentCategoryMid,
                  categoryMid: obj.selectedFolder.categoryMid,
                  categoryName: obj.updateFolderName,
                  sortNo: obj.selectedFolder.sortNo,
                  delKbn: "1",
                  act: act
                };
                let reqData = {
                  object: this,
                  data: data,
                }
                
                obj.saveCategory(reqData);
              }
            }else{
              // return false;
              obj.showAlertDialog(obj.$i18nUtil.trans("AB031","과정 내 보드가 있으면 과정 삭제 불가합니다."));
              return false;
            }
          }
        }
			}
    },
    saveCategory(_reqData) {
      let obj = this;
      let param = {
        url: '/api/copaper/category/saveCategory',
        method: 'post',
        obj: _reqData.object,
        req: _reqData.data
      };
      obj.COWORK_REST_ACTION(param)
				.then(function (res) {
					if(res.errorCode == null) {
            let savedCategory = res.result.saveCategory;
            if(_reqData.data.act == 'create') {
              let pushCategory = {category: savedCategory, categoryStatus: 'Y', paperCount: 0};
              obj.myFolderList.push(pushCategory);
              obj.addFolderName = "";
              obj.getMyPrivateBoardList(pushCategory.category);
              obj.UTS025closeModal();
            }
            else if(_reqData.data.act == 'update') {
              obj.myFolderList.forEach(myFolder => {
                if(myFolder.category.categoryMid == savedCategory.categoryMid) {
                  myFolder.category.categoryName = savedCategory.categoryName;
                }
              });
              obj.updateFolderName = "";
              obj.UTS026closeModal();
            }
            else if(_reqData.data.act == "delete") {
              let deleteIndex = -1;
              obj.myFolderList.forEach((myFolder, myFolderIndex) => {
                if(myFolder.category.categoryMid == savedCategory.categoryMid) {
                  deleteIndex = myFolderIndex;
                }
              });
              obj.myFolderList.splice(deleteIndex, 1);
              obj.getMyPrivateBoardList({});
              obj.AB028ModalcloseModal();
            }
					}
				})
				.catch(function (err) {
					console.log(err);
				});
    },
		getBoardList(folder, isSearch) {
      let obj = this;
      let pageParam = obj.page;
      //뒤로가기 접근시 데이터 set
      if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
        window.sessionStorage.setItem("moveBoard",false);
        window.sessionStorage.setItem("prevBtn",false);
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        let state = stateArr[stateArr.length-1];

        let data ={
          categoryMid : state.categoryMid,
          projectId : state.projectId,
          groupId : state.groupId
        }
        folder = data;

        //검색 설정 
        if(state.searchPaperTitle != ""){
          isSearch = true;
          this.isSearchArea = true;
          this.searchPaperTitle = state.searchPaperTitle;
        }
        
        //페이지 설정
        if(pageParam != state.page){
          obj.page = state.page;
          return;
        }

        // 테이블 정렬 설정 
          
        obj.sortBy[0] = state.sortKey;
        obj.sortDesc[0] = state.sortDesc; 

        // 미확인보드보기, 즐겨찾기 보기 체크박스 설정
        obj.isBookmarkFilter = state.isBookmarkFilter;
        obj.checkFilterRead = state.isPaperReadChecked;

        //필터 유지.
        obj.gradeCodeList = state.gradeCodeList;
        obj.statusList = state.statusList;
        obj.initFilter = {
          gradeCodeList : state.gradeCheckYn == true ? obj.gradeCodeList : [],
          statusList : state.statusCheckYn == true ? obj.statusList : []
        }          
      } else{
        if(isSearch == true) {
          if(obj.searchPaperTitle == '') {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB091","검색어를 입력해주세요.");
            obj.showToast(obj.toastInfo);
            return;
          }
          pageParam = 1;
        }
      }
			obj.boardList = [];

			let param = {
				url: '/api/copaper/paper/getCategoryPaperList',
				method: 'post',
				req: {
					categoryMid : folder.categoryMid, 
					section :"PROJECT", //'EXECUTION',  
					paperStatus : null,                       
					projectId : folder.projectId,
          groupId : folder.groupId,
          searchPaperTitle: "%%",
          limitRow: obj.itemsPerPage,
          page: 0,
          sortKey: obj.sortBy[0],
          sortDesc: obj.sortDesc[0],
          isPaperBookmarkChecked: obj.isBookmarkFilter,
          isPaperReadChecked: obj.checkFilterRead,
          gradeCodeList: obj.gradeCodeList,
          statusCodeList: obj.statusList,
				}
			};

			obj.COWORK_REST_ACTION(param)
				.then(function (res) { 
					if(res.errorCode == null) { 
            
            obj.boardList = res.result.paperList.content;
            obj.totalElements = res.result.paperList.totalElements; 
            obj.pageCount = res.result.paperList.totalPages; 
            //필터 초기화 
            obj.filterStatus=[];
            obj.filterStatus.push('SO');
            obj.filterStatus.push('GOOD');
            obj.filterStatus.push('DELAY');
            obj.filterStatus.push('EXCEEDED');
 
            obj.filterUserList = [];
            obj.filterUserArray = [];
            obj.filterUserSelected = [];
            obj.filterUserSelectedAll = true;

            obj.boardList.forEach(boardItem => {
              let regUserName = boardItem.regUserName;
              let regUserId = boardItem.regUserId;
              if(obj.filterUserArray.indexOf(regUserId) == -1){
                  obj.filterUserArray.push(regUserId);
                  obj.filterUserSelected.push(regUserId);
                  let param = {
                      userId : regUserId,
                      userName : regUserName
                  }
                  obj.filterUserList.push(param); 
              } 

              let updUserName = boardItem.regUserName;
              let updUserId = boardItem.regUserId;
              if(obj.filterUserArray.indexOf(updUserId) == -1){
                  obj.filterUserArray.push(updUserId);
                  obj.filterUserSelected.push(updUserId);
                  let param = {
                      userId : updUserId,
                      userName : updUserName
                  }
                  obj.filterUserList.push(param); 
              }
            });
 
            // obj.filterUserSelected = obj.filterUserArray; 
 
            obj.boardListFilter = obj.boardList;
            // obj.setBoardFilter();

            // sessionStorage에 저장. 
            let sessionState = JSON.parse(window.sessionStorage.getItem("private")) || [];
            if(sessionState.length != 0){

              let lastState = sessionState.pop();
              lastState.categoryMid = folder.categoryMid;
              lastState.projectId = folder.projectId;
              lastState.groupId = folder.groupId;

              lastState.searchPaperTitle = obj.searchPaperTitle;
              lastState.page = pageParam;
              lastState.isBookmarkFilter = obj.isBookmarkFilter;
              lastState.isPaperReadChecked = obj.checkFilterRead;
              lastState.sortDesc = obj.sortDesc[0];
              lastState.sortKey = obj.sortBy[0];
              lastState.limitRow = obj.itemsPerPage;
              lastState.selectedFolderIndex = obj.selectedFolderIndex;
              lastState.gradeCodeList = obj.gradeCodeList;
              lastState.statusList = obj.statusList;
              lastState.gradeCheckYn = obj.gradeCheckYn;
              lastState.statusCheckYn = obj.statusCheckYn;
              sessionState.push(lastState);
              window.sessionStorage.setItem("private", JSON.stringify(sessionState));
            }
					}
				})
				.catch(function (err) {
					console.log(err);
				});
		},
		// goBoard(paperId) {
		// 	this.$router.push('/general/board/'+paperId)
		// },
		moveBoard(board) {
      window.sessionStorage.setItem("moveBoard",true); 
      let postPath = board.paperProjectLinkId == null ? (board.paperId) :  (board.paperId+"/"+board.paperProjectLinkId); 
      let path = "/general/board/" + postPath; 
      this.$router.push(path);
    },
    getEvaluateClassAndText(board) {
      let rtnEvaluateJson = {evaluateClass: '', evaluateText: ''};
      // exceeded
      if(board.paperStatus == 'GOOD') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-good";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상");
      }
      // on track
      else if(board.paperStatus == 'SO') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-so";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생");
      }
      // at risk
      else if(board.paperStatus == 'DELAY') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-delay";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요");
      }
      // off track
      else if(board.paperStatus == 'EXCEEDED') {
        rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-exceeded";
        rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료");
      }
      return rtnEvaluateJson;
    },
		checkHours(lastUpdated) {
			let now = this.$moment()
			let before24hours = this.$moment().subtract(1,'days')
			let lastUpdatedTime = this.$moment(lastUpdated)
			
			if(lastUpdatedTime.isBetween(before24hours, now)) {
				// 24시간 이내
				return true;
			}else{
				// 24시간 이후
				return false;
			}
		}, 
		UTS025OpenModal() {
      //this.UTS025Modal = true 
      let obj = this;
        const modalInfo = {
          title: this.$i18nUtil.trans("title.CrudFolderModal.001","과정 등록"),
          name: "registFolder",
          method: "post",
          // width: "500px",
          // height: "300px",
          width: "800px",
          obj: obj.$modal,  
          groupId: this.parentCategory.groupId,
          component: CrudFolderModal,
          parentCategoryMid: this.parentCategoryMid,
          projectId: null,
          regUserId: this.parentCategory.regUserId,  
        }; 
        obj.showModal(modalInfo);
		},
		UTS025closeModal() {
			this.UTS025Modal = false
		},
		UTS026OpenModal() {
      // event.target.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active');
      //this.updateFolderName = this.selectedFolder.categoryName;
      //this.UTS026Modal = true
      
      let obj = this;
      const modalInfo = {
        title: this.$i18nUtil.trans("title.CrudFolderModal.002","과정 변경"),
        name: "updateFolder",
        method: "post",
        // width: "500px",
        // height: "300px",
        width: "800px",
        obj: obj.$modal,   
        component: CrudFolderModal,
        selectedFolder : this.selectedFolder,
        categoryName : this.selectedFolder.categoryName,
        parentCategoryMid: this.parentCategoryMid
      }; 
      obj.showModal(modalInfo);
		},
		UTS026closeModal() {
			this.UTS026Modal = false
		},
		AB028ModalOpenModal() {
      //this.AB028Modal = true DeleteFolderAlert
      // event.target.parentElement.parentElement.parentElement.parentElement.childNodes[0].classList.toggle('active');

      let obj = this;
      const modalInfo = {
        title: this.$i18nUtil.trans("title.DeleteFolderAlert.001","과정 삭제"),
        name: "updateFolder",
        method: "post",
        width: "400px",
        // height: "200px",
        obj: obj.$modal,   
        component: DeleteFolderAlert, 
        myFolderListLength : this.myFolderList.length,
        selectedFolder : this.selectedFolder, 
        parentCategoryMid: this.parentCategoryMid
      }; 
      obj.showModal(modalInfo);

		},
		AB028ModalcloseModal() {
			this.AB028Modal = false
		},
		AB032ModalOpenModal() {
			this.AB032Modal = true
		},
		AB032ModalcloseModal() {
			this.AB032Modal = false
		},
		checkMove({ draggedContext, relatedContext }) {
      this.sourceDraggableElement = draggedContext.element.category; // 드래그로 움직이는 data
      this.targetDraggableElement = relatedContext.element.category; // 밀려나는 data
    },
    onChangeDraggable(e) {
      let obj = this;
      if(
        obj.sourceDraggableElement != null && obj.sourceDraggableElement.categoryMid && obj.sourceDraggableElement.categoryMid != null
        && obj.targetDraggableElement != null && obj.targetDraggableElement.categoryMid && obj.targetDraggableElement.categoryMid != null
        ) {
          obj.updateFolderSort(obj.sourceDraggableElement, obj.targetDraggableElement);
      }
    },
    updateFolderSort(_sourceData, _targetData) {
      let obj = this;
			let param = {
				url: '/api/copaper/category/moveCategorySort',
				method: 'post',
				req: {
					groupId : _sourceData.groupId, 
					categoryMid : _sourceData.categoryMid,                       
					beforeSortNo : _sourceData.sortNo,
					pushedCategorySortNo: _targetData.sortNo,
					pushedCategoryMid: _targetData.categoryMid,
				}
			};
			obj.COWORK_REST_ACTION(param)
				.then(function (res) {
					if(res.errorCode == null) {
            if(res.result == 'SUCCESS') {
              obj.getMyFlolderList();
							obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardList.006","변경이 완료되었습니다."));
            }
					}
				})
				.catch(function (err) {
					console.log(err);
				});
    },
    /* 업무보드 추가 */
    addBoard() {
      this.$emit("addPrivateBoard", this.selectedFolder);
    },
    /* 정보공유 게시 */
    infoShareReqPost(board){
      const modalInfo = {
        title: this.$i18nUtil.trans("title.ReqPostModal.shareInfo","정보공유 게시"),
        name: "infoShareModal",
        method: "post",
        width: "800px",
        // height: "408px",
        obj: this.$modal,
        paperId: board.paperId,
        component: reqPost,
      };
      this.showModal(modalInfo);
    },
    /* 회의/협의 게시 */
    cooperationReqPost(board){
      const modalInfo = {
        title: this.$i18nUtil.trans("title.ReqPostModal.cooperation","회의/협의 게시"),
        name: "cooperationModal",
        method: "post",
        width: "800px",
        // height: "408px",
        obj: this.$modal,
        paperId: board.paperId,
        addfolderName:board.paperTitle,
        component: reqPost,
      };
      this.showModal(modalInfo);
    },
    /* 보드url 복사 */
    copyURL(text,board){
      let element = document.createElement("input");
      let s = element.style;
      s.border = "0";
      s.width = "1px";
      s.height = "1px";
      s.background = "#fff";
      s.color = "#fff";
      element.value = text+board.paperId;
      this.$el.appendChild(element);
      element.select();
      document.execCommand("copy");
      $(element).remove();
      this.toastInfo.message = this.$i18nUtil.trans('TB010','URL이 복사되었습니다.');
      this.showToast(this.toastInfo);
    },
    /* 현재 url */
    currentURL() {
      let url = window.location.href;
      let match = /^(.+)\/(private)$/.exec(url);
      if (match.length > 2) {
        url = match[1] + "/board/";
      }
      return url;
    },
    /* 업무보드 복제 */
    copyPaperModal(board) {
      const modalInfo = {
        title: this.$i18nUtil.trans("title.CopyBoardModal.001","업무보드 복제"),
        name: "copyBoardModal",
        method: "post",
        width: "800px",
        // height: "516px",
        obj: this.$modal,
        paperId: board.paperId,
        groupId: board.groupId,
        component: CopyBoardModal,
      };
      this.showModal(modalInfo);
      
    },
    /* 보드삭제 */
    deleteBoard(board){
      let obj = this;
      obj.showConfirmDialogWithJSON({
        confirmMessage: obj.$i18nUtil.trans('AB001','보드를 삭제할 경우 해당 보드에 등록된 파일과 내용이 모두 삭제되며 복구할 수 없습니다. 정말 삭제하시겠습니까?'),
        confirmBtnText: obj.$i18nUtil.trans("button.delete","삭제"),
        confirmBtnCallback: obj.deletePaperApiCall,
        modalParam: {board: board},
        cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
      });
    },
    deletePaperApiCall(callbackData) {
      let obj = this;
      let reqData = {};
      reqData.params ={
        paperId : callbackData.modalParam.board.paperId,
        groupId : callbackData.modalParam.board.groupId,
        categoryMid : callbackData.modalParam.board.categoryMid,
        deleteYn :"1"
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/paper/deletePaper";
      reqData.method = "post";
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          obj.hideLoadingbar();
          if(res.fncAuthRst != null) {
              // 삭제 권한이 없을 경우
              if(!res.fncAuthRst.allow) {
                  obj.toastInfo.message = obj.$i18nUtil.trans('TB056','삭제 권한이 없습니다.');
                  obj.showToast(obj.toastInfo);
                  return;
              }
          }
          obj.toastInfo.message = obj.$i18nUtil.trans('TB027','보드가 삭제되었습니다.');
          obj.showToast(obj.toastInfo);
          const idx = obj.boardList.findIndex(function(data) {
            return data.paperId == callbackData.modalParam.board.paperId;
          });
          obj.boardList.splice(idx,1);
          const index = obj.boardListFilter.findIndex(function(data) {
            return data.paperId == callbackData.modalParam.board.paperId;
          });
          obj.setBoardFilter();
          obj.myFolderList.forEach(elem => {
            if(elem.category.categoryMid === obj.selectedFolder.categoryMid) {
              elem.paperCount = elem.paperCount - 1;
            }
          });

        })
        .catch(function(err) {
          console.log(err);
        });
    },
    fireFilterBookmark(){
      let obj = this;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
      // obj.setBoardFilter();
    },
    fireFilterPaperStatus(paperStatus) {
      let obj = this;
      obj.filterPaperStatus = paperStatus;
      obj.setBoardFilter();
    },
    fireFilterLastUpdUserInfo(lastUpdInfo) {
      let obj = this;
      obj.filterLastUpdUser.filterLastUpdUserId = lastUpdInfo.lastUpdUserId;
      obj.filterLastUpdUser.filterLastUpdUserName = lastUpdInfo.lastUpdUserName;
      obj.setBoardFilter();
    },
    updateCommonFilterE(filterData) {
      let obj = this;
      obj.gradeCodeList = filterData.filterGradeList;
      obj.statusList = filterData.filterStatusList;
      obj.gradeCheckYn = filterData.gradeCheckYn;
      obj.statusCheckYn = filterData.statusCheckYn;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    setBoardFilter() {
      let obj = this;
      // 즐겨찾기 필터링
      let bookmarkChecked = obj.isBookmarkFilter;
      if(bookmarkChecked) {
        const result = obj.boardList.filter(function(board){
          return board.paperBookmarkId != null;
        });
        obj.boardListFilter = result;
      } else {
        obj.boardListFilter = obj.boardList;
      }

      // 진행상태 필터링
      // let filterPaperStatus = obj.filterPaperStatus;
      // if(filterPaperStatus !== "ALL") {
      //   const result = obj.boardListFilter.filter(function(board){
      //     return board.paperStatus === filterPaperStatus;
      //   });
      //   obj.boardListFilter = result;
      // } else {
      //   obj.boardListFilter = obj.boardListFilter;
      // }
      // if($("#dtFilterPaperStatus")[0].classList.contains("active")) {
      //   $("#dtFilterPaperStatus")[0].classList.remove("active");
      // }

      // 생성/수정자 필터링
      // let filterLastUpdUserId = obj.filterLastUpdUser.filterLastUpdUserId;
      // if(filterLastUpdUserId !== "ALL") {
      //   const result = obj.boardListFilter.filter(function(board){
      //     return board.lastUpdUserId === filterLastUpdUserId;
      //   });
      //   obj.boardListFilter = result;
      // } else {
      //   obj.boardListFilter = obj.boardListFilter;
      // }
      // if($("#dtFilterUpdUser")[0].classList.contains("active")) {
      //   $("#dtFilterUpdUser")[0].classList.remove("active");
      // }
      // obj.greenCount = 0;
      // obj.yellowCount = 0;
      // obj.redCount = 0;
      // obj.boardListFilter.forEach(board => {
      //   obj.greenCount += board.paperSignal === "G" ? 1 : 0;
      //   obj.yellowCount += board.paperSignal === "Y" ? 1 : 0;
      //   obj.redCount += board.paperSignal === "R" ? 1 : 0;
      // });
    },
    /* 즐겨찾기 설정/해제 */
    toggleBookmark(board) {
      let obj = this;
      let reqData = {};
      reqData.params ={
        paperId: board.paperId,
        bookmarkId:board.paperBookmarkId
      }
      reqData.req = obj.req;
      reqData.url = "/api/copaper/bookmark/savePaperBookmark";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => {
          board.paperBookmarkId = res.result;
          if(board.paperBookmarkId != null) {
            obj.toastInfo.message = obj.$i18nUtil.trans('TB041','즐겨찾기가 설정되었습니다.');
            obj.showToast(obj.toastInfo);
          } 
          else {
            obj.toastInfo.message = obj.$i18nUtil.trans('TB042','즐겨찾기가 해제되었습니다.');
            obj.showToast(obj.toastInfo);
          }
          obj.changeTableData = true;
        }) 
        .catch(function(err) {
          console.log(err);
        });
    },
    getPaperUserList(item, _event) {
      if(_event.target.parentElement.classList != null && _event.target.parentElement.classList.contains("active")) {
        _event.target.parentElement.classList.toggle("active");
        return;
      }
      let obj = this;
      let url = "/api/copaper/paperuser/getPaperUserList";
      let param = {};
      param = {
        paperId: item.paperId,
      };
      axios
        .post(url, param)
        .then(res => {
          if (res.data.errorCode != null) {
            return;
          }
          Vue.set(item, "paperUserList", res.data.result.userList);
          Vue.set(item, "paperUserCount", res.data.result.userList == null ? 0 : res.data.result.userList.length);
          _event.target.parentElement.classList.toggle('active');
        })
        .catch(err => {
          console.log("axios err => ", err);
        });
    }, 
    replaceAll(str, input, output) {
      return str.split(input).join(output);
    },   
    efilterStatus(filter){ 
      let status = filter; 
      if(status =="ALL"){
        if(event.target.parentElement.classList.length == 1){
          this.filterStatus =[];
          let nodes = event.target.parentElement.parentElement.childNodes;
          for(let k in nodes){ 
            if(nodes[k].nodeName =="LI"){  
              nodes[k].classList.remove('active'); 
            }
          }
        }else{
          this.filterStatus.push('SO');
          this.filterStatus.push('GOOD');
          this.filterStatus.push('DELAY');
          this.filterStatus.push('EXCEEDED');
          let nodes = event.target.parentElement.parentElement.childNodes;
          for(let k in nodes){ 
            if(nodes[k].nodeName =="LI"){
              nodes[k].classList.add('active'); 
            }
          } 
        } 
      }else{
        if(this.filterStatus.indexOf(status) == -1){
            event.target.parentElement.classList.toggle('active');
            this.filterStatus.push(status);
        }else{
            event.target.parentElement.classList.toggle('active');
            this.filterStatus.splice(this.filterStatus.indexOf(status),1);
        }   
  
        if(this.filterStatus.length == 4){ 
            event.target.parentElement.parentElement.childNodes[0].classList.add('active');
        }else{ 
            event.target.parentElement.parentElement.childNodes[0].classList.remove('active');
        } 
      }
      this.setFilter(); 
    }, 
    setFilterUserAll(){ 
      if(this.filterUserSelectedAll){
        this.filterUserSelected = this.filterUserArray; 
        // for(let k in this.regUSersInfo){
        //     this.selectedRegUserArr.push(this.regUSersInfo[k].userId);
        // }
      }else{ 
        this.filterUserSelected = [];
      } 
        
      this.setFilter();
    },
    setfilterUser(filter){  
      this.filterUserSelectedAll=false;  
  
      if(this.filterUserSelected.indexOf(filter) == -1){  
          this.filterUserSelected.push(filter); 
      }else{ 
          this.filterUserSelected.splice(this.filterUserSelected.indexOf(filter),1); 
      } 
     
      if(this.filterUserSelected.length === this.filterUserArray.length){
          this.filterUserSelectedAll=true;
      }
      this.setFilter();
    },
    setFilter(){
      //상태 필터 
      this.boardListFilter = this.boardList; 
      let jsonString ="["; 
      for(let k in this.filterStatus){
          let status = this.filterStatus[k];
          const result = this.boardListFilter.filter(function(data){
              return data.paperStatus == status;
          })  
          if(result.length != 0){ 
              let jsonResult = JSON.stringify(result);
              jsonString += jsonResult.substring(1,jsonResult.length-1) +','; 
          } 
      } 
      if(jsonString.length != 1){
          jsonString = jsonString.slice(0,-1)+"]";
      }else{
          jsonString = "[]";
      }
      this.boardListFilter= JSON.parse(jsonString);

      // 생성 수정자 필터   
      jsonString ="["; 
      for(let k in this.filterUserSelected){
          let userId = this.filterUserSelected[k];
          const result = this.boardListFilter.filter(function(data){
              return data.regUserId == userId || data.lastUpdUserId == userId;
          })  
          if(result.length != 0){ 
              let jsonResult = JSON.stringify(result);
              jsonString += jsonResult.substring(1,jsonResult.length-1) +','; 
          } 
      } 
      if(jsonString.length != 1){
          jsonString = jsonString.slice(0,-1)+"]";
      }else{
          jsonString = "[]";
      }
      this.boardListFilter= JSON.parse(jsonString);
    },
    checkReadfilter(){
      let obj = this;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
    },
    clearSearchPaperTitle() {
      let obj = this;
      obj.searchPaperTitle = '';
      obj.rtnSearchPaperTitle = '';
      obj.showSearchBoardTitle = false;
      if(obj.page == 1) {
        obj.changeTableData = true;
      } else {
        obj.page = 1;
      }
      // obj.getListTabDashboardBoardList(null, false);
    },
    getListTabDashboardBoardList(folder, isSearch) {
      let obj = this;
      let pageParam = obj.page;
      //뒤로가기 접근시 데이터 set
      if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
        window.sessionStorage.setItem("moveBoard",false);
        window.sessionStorage.setItem("prevBtn",false);
        let stateArr = JSON.parse(window.sessionStorage.getItem("private")) || [];
        let state = stateArr[stateArr.length-1];

        let data ={
          categoryMid : state.categoryMid,
          projectId : state.projectId,
          groupId : state.groupId
        }
        folder = data;

        //검색 설정 
        if(state.searchPaperTitle != ""){
          isSearch = true;
          this.isSearchArea = true;
          this.searchPaperTitle = state.searchPaperTitle;
        }
        
        //페이지 설정 
        if(pageParam != state.page){
          obj.page = state.page;
          return;
        }

        // 테이블 정렬 설정 
          
        obj.sortBy[0] = state.sortKey;
        obj.sortDesc[0] = state.sortDesc; 

        // 미확인보드보기, 즐겨찾기 보기 체크박스 설정
        obj.isBookmarkFilter = state.isBookmarkFilter;
        obj.checkFilterRead = state.isPaperReadChecked;

        //필터 유지.
        obj.gradeCodeList = state.gradeCodeList;
        obj.statusList = state.statusList;
        obj.initFilter = {
          gradeCodeList : state.gradeCheckYn == true ? obj.gradeCodeList : [],
          statusList : state.statusCheckYn == true ? obj.statusList : []
        }          
      } else{
        if(isSearch == true) {
          if(obj.searchPaperTitle == '') {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB091","검색어를 입력해주세요.");
            obj.showToast(obj.toastInfo);
            return;
          }
          pageParam = 1;
        }
      } 
      
      let selectedFolderInfo = folder || obj.selectedFolder;
      obj.boardListFilter = [];
      if(obj.searchPaperTitle != null && obj.searchPaperTitle != undefined && obj.searchPaperTitle.length > 0) {
        obj.showSearchBoardTitle = true;
      } else {
        obj.showSearchBoardTitle = false;
      }
      obj.rtnSearchPaperTitle = obj.searchPaperTitle;
      let param = {
        url: '/api/copaper/paper/getCategoryPaperList',
        method: 'post',
        req: {
          categoryMid : selectedFolderInfo.categoryMid, 
          projectId : selectedFolderInfo.projectId,
          searchPaperTitle: "%" + obj.searchPaperTitle + "%",
          limitRow: obj.itemsPerPage,
          page: pageParam - 1,
          sortKey: obj.sortBy[0],
          sortDesc: obj.sortDesc[0],
          isPaperBookmarkChecked: obj.isBookmarkFilter,
          isPaperReadChecked: obj.checkFilterRead,
          gradeCodeList: obj.gradeCodeList,
          statusCodeList: obj.statusList,
        }
      };
      //프로그레스바 시작 
      this.showLoadingbar();
      obj.COWORK_REST_ACTION(param)
        .then(function (res) {
          //프로그레스바 종료
          obj.hideLoadingbar();
          if(res.errorCode == null) {
            // obj.boardList = res.result.paperList; 
            // obj.boardListFilter = obj.boardList;  
            obj.boardListFilter = res.result.paperList.content; 
            obj.totalElements = res.result.paperList.totalElements; 
            obj.pageCount = res.result.paperList.totalPages; 

            // sessionStorage에 저장. 
            let sessionState = JSON.parse(window.sessionStorage.getItem("private")) || [];
            if(sessionState.length != 0){
              let lastState = sessionState.pop();
              lastState.categoryMid = selectedFolderInfo.categoryMid;
              lastState.projectId = selectedFolderInfo.projectId;
              lastState.groupId = selectedFolderInfo.groupId;
              lastState.searchPaperTitle = obj.searchPaperTitle;
              lastState.page = pageParam;
              lastState.isBookmarkFilter = obj.isBookmarkFilter;
              lastState.isPaperReadChecked = obj.checkFilterRead;
              lastState.sortDesc = obj.sortDesc[0];
              lastState.sortKey = obj.sortBy[0];
              lastState.limitRow = obj.itemsPerPage;
              lastState.selectedFolderIndex = obj.selectedFolderIndex;
              lastState.gradeCodeList = obj.gradeCodeList;
              lastState.statusList = obj.statusList;
              lastState.gradeCheckYn = obj.gradeCheckYn;
              lastState.statusCheckYn = obj.statusCheckYn;
              sessionState.push(lastState);
              window.sessionStorage.setItem("private", JSON.stringify(sessionState));
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      },
  },
}


</script>

<style scoped>
.ico-txt_comment{
  position: relative;
  line-height: 16px;
  padding-left: 19px;
  font-size: 14px; 
      
    display: block;
    content: '';
    width: 16px;
    height: 16px; 
    left:19px
}

.folder_ty1 .folder_nav .folder_list > div:hover > button::after { 
    background: none; 
}
.check_result{
  background-color: #f6f7fa;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/mypage/private/tab/board/BoardList.vue